<template>
    <el-card class="risk-area-main">
        <div class="clearfix card-head" slot="header">
            <el-row :gutter="10">
                <el-col :span="12" class="card-title">Risk Area</el-col>
                <el-col :span="3" class="card-buttons">
                    <el-button-group>
                        <el-button size="small" icon="el-icon-circle-plus-outline" @click="openAddEditRiskAreaDialog()">
                            Add New
                        </el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="3">
                    <el-select size="small" v-model="riskAreaTable.filters.sourceType.value" clearable
                               placeholder="Filter Source Type">
                        <el-option v-for="obj in sourceType" :key="obj.value" :label="obj.label"
                                   :value="obj.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" class="search">
                    <el-input size="small" v-model="riskAreaTable.filters.nameAbbr.value"
                              suffix-icon="el-icon-search"
                              placeholder="Search by name/abbreviation..."></el-input>
                </el-col>
            </el-row>
        </div>
        <div class="card-body">
            <data-tables
                    ref="riskAreaTable"
                    :data="riskAreaTable.data"
                    v-loading="riskAreaTable.loading"
                    :pageSize="10"
                    :pagination-props="riskAreaTable.paginationProps"
                    border
                    style="width: 100%"
                    :filters="Object.values(riskAreaTable.filters)">
                <el-table-column prop="abbreviation" label="Abbreviation" width="150"
                                 :sortable="true"></el-table-column>
                <el-table-column prop="name" label="Name" :sortable="true"></el-table-column>
                <el-table-column prop="active" label="Status" :sortable="true">
                    <template slot-scope="prop">
                        <span v-text="riskAreaTable.activeMapping[+prop.row.active]"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="order" label="Order" :sortable="true"></el-table-column>
                <el-table-column prop="type" label="Type" :sortable="true">
                    <template slot-scope="props">
                        <span v-text="riskAreaType.find(obj=>obj.value===props.row.type).label"></span>
                    </template>
                </el-table-column>
                <el-table-column width="80">
                    <template slot-scope="prop">
                        <el-tooltip effect="dark" :open-delay="1000" :content="'Edit '+prop.row.abbreviation"
                                    placement="top">
                            <el-button
                                    class="action-btn"
                                    @click.native.prevent="openAddEditRiskAreaDialog(prop.row.abbreviation)"
                                    icon="el-icon-edit-outline"
                                    type="text">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip effect="dark" :open-delay="1000" :content="'Delete '+prop.row.abbreviation"
                                    placement="top">
                            <el-button
                                    class="action-btn"
                                    @click.native.prevent="deleteRiskArea(prop.row.abbreviation)"
                                    icon="el-icon-delete"
                                    type="text">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </data-tables>
        </div>
        <add-edit-risk-area-dialog v-bind:loading.sync="riskAreaTable.loading"
                                   ref="addEditRiskAreaDialog"></add-edit-risk-area-dialog>
    </el-card>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import AddEditRiskAreaDialog from './AddEditRiskAreaDialog';

    const {mapState, mapActions} = createNamespacedHelpers('riskIndex');

    export default {
        name:        "RiskAreaMain",
        components:  {AddEditRiskAreaDialog},
        data() {
            return {
                sourceType:    [
                    {
                        value: 'quant',
                        label: 'Quantitative'
                    }, {
                        value: 'qual',
                        label: 'Qualitative'
                    }
                ],
                riskAreaTable: {
                    data:            [],
                    loading:         true,
                    selectedRow:     {},
                    paginationProps: {
                        background: true,
                        pageSizes:  [10, 20, 30]
                    },
                    filters:         {
                        nameAbbr:   {
                            prop:     'name',
                            value:    '',
                            filterFn: (row, filters) => {
                                return row.name.toLowerCase().indexOf(filters.value.toLowerCase()) >= 0 || row.abbreviation.toLowerCase().indexOf(filters.value.toLowerCase()) >= 0;
                            }
                        },
                        sourceType: {
                            prop:     'type',
                            value:    '',
                            filterFn: (row, filters) => {
                                return row.type === filters.value;
                            }
                        }
                    },
                    activeMapping:   [
                        'Inactive',
                        'Active',
                        'Under Analysis'
                    ]
                },
                riskAreaType:  [
                    {
                        value: 'quant',
                        label: 'Quantitative'
                    }, {
                        value: 'qual',
                        label: 'Qualitative'
                    }
                ]
            };
        }, computed: {
            ...mapState(['riskAreaData'])
        },
        methods:     {
            ...mapActions([]),
            constructRiskAreaTableData: function () {
                let self      = this;
                let table     = self.riskAreaTable;
                table.loading = true;
                if (!Object.keys(self.riskAreaData).length)
                    return;
                table.data = Object.values(self.riskAreaData);
                self.$nextTick(function () {
                    self.$refs.riskAreaTable.$refs.elTable.sort('abbreviation', 'ascending');
                });
                table.loading = false;
            },
            openAddEditRiskAreaDialog:  function (abbr = '') {
                this.$refs.addEditRiskAreaDialog.open(abbr);
            },
            deleteRiskArea:             async function (abbr) {
                await this.$refs.addEditRiskAreaDialog.delete(abbr);
            }
        },
        watch:       {
            riskAreaData: {
                handler: function () {
                    this.constructRiskAreaTableData();
                },
                deep:    true
            }
        },
        mounted() {
            this.constructRiskAreaTableData();
        }
    };
</script>

<style scoped lang="scss">
    @import "@/styles/_base.scss";

    .risk-area-main {
        &::v-deep .el-card__header {
            padding-top: 10px;
            padding-bottom: 10px;
        }

        .card-head {
            .el-select {
                display: block;
            }
        }

        .card-title {
            line-height: 32px;
        }

        .card-buttons {
            text-align: right;
        }

        .action-btn {
            padding: 2px 3px;
        }
    }
</style>